import {
  sessionNumberFormatter,
  sessionStatusFormatter,
  sessionTypeFormatter,
  sessionStatusToCopy,
  dateTimeFormatter,
  clientIdFormatter,
} from '../../utils/formatters';

export const MODULE_NAME = 'SESSION_LOG_PAGE';

const getTypeLabel = (value, row) => {
  const normalized = row?.type || row?.session_type || value;
  const map = {
    REGULAR: 'Разовая',
    PREFERENTIAL: 'Льготная',
    SUBSCRIPTION: 'Абонемент',
    WHITE_LIST: 'Белый список',
    regular: 'Разовая',
    preferential: 'Льготная',
    subscription: 'Абонемент',
    white_list: 'Белый список',
  };

  return row?.type_label || row?.session_type_label || map[normalized] || normalized || '';
};

const getReasonValue = (value, row) => value || row?.session_reason || '';

const normalizeIdentifierLabel = value => {
  if (!value) {
    return '';
  }

  const normalized = String(value).trim().toUpperCase();

  if (normalized === 'ГОСУДАРСТВЕННЫЙ РЕГИСТРАЦИОННЫЙ ЗНАК') {
    return 'ГРЗ';
  }

  if (normalized === 'РАЗОВЫЙ ТАЛОН') {
    return 'Талон';
  }

  const map = {
    LPN: 'ГРЗ',
    TICKET: 'Талон',
    CARD: 'Карта',
    SUBSCRIPTION: 'Абонемент',
    RFID: 'RFID',
    QR: 'QR-код',
    QR_CODE: 'QR-код',
    BARCODE: 'Штрихкод',
  };

  return map[normalized] || value;
};

const getSessionTitle = (_, row) => {
  const labelRaw = row?.client_entry_identifier_label || row?.client?.entry_identifier_label || row?.client?.entry_identifier;
  const label = normalizeIdentifierLabel(labelRaw);
  const value = row?.client_identifier_value
    || row?.client?.identifier_value
    || row?.ticket_number
    || row?.client?.lpn
    || '';

  if (!label || !value) {
    return 'Сессия';
  }

  return `Сессия (${label}: ${value})`;
};

export const sessionLogColumns = [
  {
    dataField: 'id',
    text: 'ID сессии',
    disableSort: true,
    formatter: sessionNumberFormatter,
    toCopyFormatter: value => value || '',
    dataClassName: 'align-middle',
    headerClassName: 'id-column',
    hidden: true,
  },
  {
    dataField: 'session_title',
    text: 'Сессия',
    disableSort: true,
    formatter: getSessionTitle,
    toCopyFormatter: getSessionTitle,
    dataClassName: 'align-middle',
    headerClassName: 'description-column',
    hidden: false,
  },
  {
    dataField: 'type',
    text: 'Тип',
    disableSort: true,
    formatter: (value, row) => sessionTypeFormatter(getTypeLabel(value, row)),
    toCopyFormatter: getTypeLabel,
    dataClassName: 'align-middle',
    headerClassName: 'type-column',
    hidden: false,
  },
  {
    dataField: 'status',
    text: 'Статус',
    disableSort: true,
    dataClassName: 'align-middle',
    formatter: sessionStatusFormatter,
    toCopyFormatter: sessionStatusToCopy,
    headerClassName: 'status-column',
    hidden: false,
  },
  {
    dataField: 'started_at',
    text: 'Дата и время начала',
    disableSort: true,
    dataClassName: 'align-middle',
    formatter: date => dateTimeFormatter(date),
    toCopyFormatter: dateTimeFormatter,
    headerClassName: 'date-time-column',
    hidden: false,
  },
  {
    dataField: 'ended_at',
    text: 'Дата и время окончания',
    disableSort: true,
    dataClassName: 'align-middle',
    formatter: date => dateTimeFormatter(date),
    toCopyFormatter: dateTimeFormatter,
    headerClassName: 'date-time-column',
    hidden: false,
  },
  {
    dataField: 'client_id',
    text: 'ID клиента',
    disableSort: true,
    dataClassName: 'align-middle',
    headerClassName: 'id-column',
    formatter: clientIdFormatter,
    toCopyFormatter: value => value || '',
    hidden: true,
  },
  {
    dataField: 'reason',
    text: 'Причина закрытия',
    disableSort: true,
    formatter: getReasonValue,
    toCopyFormatter: getReasonValue,
    dataClassName: 'align-middle',
    headerClassName: 'description-column',
    hidden: false,
  },
];

export const sessionLogGridColumns = sessionLogColumns.filter(column => column.dataField !== 'client_id');

export const addSessionLogColumns = [];
